
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = $('body').data('money-format');
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function changeComparePrice(time){
  $('.product__info-container .price__loader').show();
  $('.product__info-container .price__regular').hide();
  setTimeout(function() {

    var count=0;
    var x=setInterval(function(){

    var price = $('.product__info-container .price__regular .price-item--regular').data('price');
   
    $('.gpo-element .gpo-swatches input[type="radio"]:checked').each(function(i, obj) {
      var price_addon = $(this).closest('.gpo-element').find('.gpo-label span.addOn').text();
      price_addon = price_addon.replace(" ", "").replace("(", "").replace(")", "").replace("+$","").replace("+£","").replace("+€","").replace(",",".");
      //console.log(price_addon);
      price_addon = price_addon * 100;
      //console.log(price_addon);
      price = parseInt(price) + price_addon;
    });

    $('.spice-spa-addon-product-item').each(function(i, obj) {
      var checkbox = $(this).find('.spice-spa-addon-checkbox-input:checked');
      if (checkbox.length > 0){
         var variant_price =  $(this).find('.spice-spa-addon-price-main').attr('variant_price');
         var variant_quantity =  $(this).find('[name="sg-pro-access-qty"]').val();
        variant_price = parseInt(variant_price) * variant_quantity;
        //console.log(variant_price);
        price = parseInt(price) + variant_price;
      }
    });

    var percent_price = $('.product__info-container .price__regular .price-item--regular').data('percent');
    var calculator_price = (100 - percent_price) * 0.01;
    var compare_price = price / calculator_price; 
    //var sale_price = price * calculator_price; 

      $('.product__info-container .price__regular .price-item--regular').text(Shopify.formatMoney(price, $('body').data('money-format')));
      $('.product__info-container .price__regular .price-item--sale').text(Shopify.formatMoney(compare_price, $('body').data('money-format')));
      
      if(count > 5){
        console.log('stop Interval');
        clearInterval(x);
        $('.product__info-container .price__loader').hide();
        $('.product__info-container .price__regular').show();
      }
      count++;
    }, time);
    
  }, 1000);
}

function changeBackground(){
  setTimeout(function() {
    var pictureType = $('input[name="Select Picture Style"]:checked').val();
    var premadeBackground = $('input[name="Select Background"]:checked').val();
    
    var combined = pictureType +' - '+ premadeBackground;
    combined = combined.toLowerCase().replace("'", "").replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    if(combined != ''){ 
      var sectionID = $('#product-section-id').val();                           
      var imageID = $('.img-'+combined).data('image-id');
      const mediaGallery = document.getElementById('MediaGallery-'+sectionID);
      mediaGallery.setActiveMedia(sectionID+'-'+imageID, true);
      const modalContent = document.querySelector('#ProductModal-'+sectionID+' .product-media-modal__content');
      const newMediaModal = modalContent.querySelector('[data-media-id="'+imageID+'"]');
      modalContent.prepend(newMediaModal);
    }
    
  }, 300);
}

function changeAddonAdditionalInfo(){

  $('.spice-spa-addon-product-item').each(function(i, obj) {
    var checkbox = $(this).find('.spice-spa-addon-checkbox-input:checked');
    if (checkbox.length > 0){
   
      var AdditionalField =  $(this).find('.spice-spa-addon-product-text-field');
      if (AdditionalField.length > 0){
      
        var pid= $(this).find('.spice_properties');               
        var headingName = $('.product__info-container .product__title').text();
        var numberValue = $('input[name="Select Number of People and Pets"]:checked').val();
        var styleValue = $('input[name="Select Picture Style"]:checked').val();
        var backgroundValue = $('input[name="Select Background"]:checked').val();

        var stringInfo = $.trim(headingName);
             
        if(numberValue != ''){
          stringInfo += ' - ' + numberValue;
        }
        if(styleValue != ''){
          stringInfo += ' - ' + styleValue;
        }
        if(backgroundValue != ''){
          stringInfo += ' - ' + backgroundValue;
        }
        pid.text(stringInfo);
      }
    }
  });
  
}

function checkRequiredFields(){
  var check_error = false;
  $('.gpo-form__group.show-addon-for-option').each(function(i, obj) {
    if($(this).hasClass("has-error")){
      check_error = true;
    }
  });  
  if(!check_error){
    $('button.product-form__submit').attr('disabled',false);
  }else{
    $('button.product-form__submit').attr('disabled',true);
    $('input.spice-spa-addon-checkbox-input').each(function(i, obj) {
      $(this).prop("checked",false);
    });
  }
}

$( window ).on( "load", function() {

  // Border text for AU Father’s Day
  $('.product__info-container p.product__text').each(function(i, obj) {
    console.log($(this).text());
    
    if($(this).text().indexOf('AU Father’s Day Special') != -1){
        $(this).addClass('border');
    }
  });

  // custom dropdown Number of People and Pets
  setTimeout(function() {
    $('#custom-dropdown').change(function(){
      console.log($(this).val());
      const number = $(this).val();
      $('input[name="Select Number of People and Pets"][value="'+number+'"]').prop('checked', true);
      changeComparePrice(200);
    });

    $('#custom-dropdown-gift').change(function(){
      console.log($(this).val());
      const giftVal = $(this).val();
      $('input[name="Denominations"][value="'+giftVal+'"]').prop('checked', true);
    });

    
  }, 500);  

  $('.gpo-element .gpo-swatches input[type="radio"]').click(function(){
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 500);
  });
  
  $('input[name="Select Background"]').click(function(){
    changeBackground();
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    checkRequiredFields();
  });
  
  $('input[name="Select Picture Style"]').click(function(){
    changeBackground();
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 1000);
  });
  
  $('input[name="Select Number of People and Pets"]').click(function(){
    changeComparePrice(200);
    changeAddonAdditionalInfo();
    setTimeout(function() {
      checkRequiredFields();
    }, 1000);
  });

  

   $('.require-merch-label').click(function(event) {
      var isChecked = $('#require-merch').is(':checked');
      console.log(isChecked);
      var checkboxValue = $('#require-merch:checked').val();
      console.log(checkboxValue);
      if(isChecked){
        $(this).find('.checkbox__symbol').removeClass('active');
      }else{
        $(this).find('.checkbox__symbol').addClass('active');
      }
  });  

  
   $('.main-product-form .product-form__submit').click(function(event) {
    var isChecked = $('#require-merch').is(':checked');
      console.log(isChecked);
      if(!isChecked){
        $('.require-merch-label').shake();
        return false;
      }
  });  
  

  setTimeout(function() {

    if($('.gpo-element .gpo-swatches input[type="radio"]').length > 0){
      changeComparePrice();
    }
    
    

    /* Update Step # for each Section */
    // Step 1
    var step = 1;
    var label_text = $('.gpo-element.select-background').find('.label-content').text();
    label_text = "STEP "+step+": "+label_text;
    $('.gpo-element.select-background').find('.label-content').text(label_text);
  
    // Step 2
    step +=1;
    var select_number_text = $('.product-form__input.select-number-of-people-and-pets').find('.form__label').text();
    select_number_text = "STEP "+step+": "+select_number_text;
    $('.product-form__input.select-number-of-people-and-pets').find('.form__label').text(select_number_text);
    $('.product-form__input.select-number-of-people-and-pets-custom-dropdown').find('.form__label').text(select_number_text);
    // Step 3
    step +=1;
    var select_style_text = $('.product-form__input.select-picture-style').find('.form__label').text();
    select_style_text = "STEP "+step+": "+select_style_text;
    $('.product-form__input.select-picture-style').find('.form__label').text(select_style_text);
    // Step 4
    step +=1;
    var upload_text = $('.uploadkit .uploadkit-label').text();
    upload_text = "STEP "+step+": "+upload_text;
    $('.uploadkit .uploadkit-label').text(upload_text);

    // Step 5
    // Get the element to move - price
    const drawingNotesToMove = document.querySelector('.gpo-element.drawing-notes'); 
    // Move the element
    const drawingNotes = document.querySelector('.drawing-notes-wrapper');
    if(drawingNotes){
      drawingNotes.append(drawingNotesToMove); 
      step +=1;
      var label_text = $('.gpo-element.drawing-notes').find('.label-content').text();
      label_text = "STEP "+step+": "+label_text;
      $('.gpo-element.drawing-notes').find('.label-content').text(label_text);
    }

    //Step 6
    step +=1;
    var addons_text = $('#spiceaddonsappid .spice-spa-addon-heading').text();
    //addons_text = "STEP "+step+" (OPTIONAL): "+addons_text;
    addons_text = "STEP "+step+": "+addons_text;
    $('#spiceaddonsappid .spice-spa-addon-heading').text(addons_text);
    
  }, 500);
  
  /* Sticky Preview
  var windowWidth = $(window).width();
  if (windowWidth <= 750 && $('.product-form__submit').length > 0) {
    $(window).scroll(function() {

      if ($(this).scrollTop() > 106 ) {
        //$('.product__media-wrapper').addClass("sticky");
        //$('.product__info-wrapper').addClass("sticky");
        $('.product__media-wrapper').addClass("preview");
        $('.product__info-wrapper').addClass("preview");
      }else{
        //$('.product__media-wrapper').removeClass("sticky");
        //$('.product__info-wrapper').removeClass("sticky");
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

      if ($(this).scrollTop() > $('.product-form__submit').offset().top ) {
        //$('.product__media-wrapper').removeClass("sticky");
        //$('.product__info-wrapper').removeClass("sticky");
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

    });
  }
  */

});

/*
$(window).on('resize', function() {
  var windowWidthResize = $(window).width();
  if (windowWidthResize <= 750 && $('.product-form__submit').length > 0) {
    $(window).scroll(function() {

      if ($(this).scrollTop() > 106 ) {
        $('.product__media-wrapper').addClass("preview");
        $('.product__info-wrapper').addClass("preview");
      }else{
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }

      if ($(this).scrollTop() > $('.product-form__submit').offset().top ) {
        $('.product__media-wrapper').removeClass("preview");
        $('.product__info-wrapper').removeClass("preview");
      }
      
     });
  }
});  
*/

$('.hero__reviews').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots:true,
  autoplay:true,
  autoplaySpeed:3500,
  fade: false
});



$window = $(window);
$slick_slider = $('.js-text-slider');
settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  nextArrow: '<span class="arrow-next arrow-btn"><i class="fa fa-angle-right" aria-hidden="true"></i></span>',
  prevArrow: '<span class="arrow-prev arrow-btn"><i class="fa fa-angle-left" aria-hidden="true"></i></span>',

};
$slick_slider.slick(settings);

$( window ).on( "load", function() {
  if ($window.width() > 991) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
});

function stickyAddToCart(){
   console.log('Sticky clicked!');
   $('html, body').animate({
      scrollTop: $('#product-form__buttons').offset().top - 100
    }, 1000);
    $('#product-form__buttons .product-form__submit').css('animation','pulse-attention 2s infinite');
}

$window.on('resize', function() {
  if ($window.width() > 991) {
    if ($slick_slider.hasClass('slick-initialized'))
      $slick_slider.slick('unslick');
    return
  }
  if ( ! $slick_slider.hasClass('slick-initialized'))
    return $slick_slider.slick(settings);
});  
                            
$(function() {
    var stickyBtn = $(".sticky-btn-bottom");
    var s = $("#MainContent");
    var pos = s.position();

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll > pos.top) {
            stickyBtn.addClass("active");
        } else {
            stickyBtn.removeClass("active");
        }
    });
});


$(window).scroll(function () {
  
  var priceSection = $('.price-section');
  if (priceSection.length) {
   const checkScrollToDiv = $('.price-section').offset().top + $('.price-section').outerHeight();
    if ($(window).scrollTop() >= checkScrollToDiv) {
      $('.price-section .price').addClass('active-sticky');
    }else if($(window).scrollTop() < $('.price-section .price').offset().top + $('.price-section .price').outerHeight()){
      $('.price-section .price').removeClass('active-sticky');
    }
  }
  
}); 


jQuery.fn.shake = function (interval, distance, times) {
  (interval = typeof interval > "u" ? 100 : interval), (distance = typeof distance > "u" ? 10 : distance), (times = typeof times > "u" ? 3 : times);
  var jTarget = $(this);
  jTarget.css("position", "relative");
  for (var iter = 0; iter < times + 1; iter++) jTarget.animate({ left: iter % 2 == 0 ? distance : distance * -1 }, interval);
  return jTarget.animate({ left: 0 }, interval);
};
